import {
  LANGUAGE_CONFIG,
  SPEECH_ENGINES
} from './speechLanguageConfig';

import {
  webSpeechEngine
} from './webSpeechApi';

import {
  elevenLabsEngine,
  hasElevenLabsCache,
  stopElevenLabsPlayback
} from './elevenLabsApi';

const GENERATE_DEBOUNCE_MS = 400;

let currentElevenLabsAudio = null;
let playTimer = null;

export const setCurrentElevenLabsAudio =
  (audio) => {
    currentElevenLabsAudio =
      audio;
  };

export const stopCurrentAudio = () => {
  if (playTimer) {
    clearTimeout(playTimer);
    playTimer = null;
  }

  stopElevenLabsPlayback();

  if (window.speechSynthesis) {
    window.speechSynthesis.cancel();
  }

  if (currentElevenLabsAudio) {
    currentElevenLabsAudio.pause();
    currentElevenLabsAudio.currentTime = 0;
    currentElevenLabsAudio = null;
  }
};

export const playPageAudio = async (
  text,
  locale,
  isLoggedIn
) => {

  stopCurrentAudio();

  if (!text?.trim()) {
    return;
  }

  const config =
    LANGUAGE_CONFIG[locale] ||
    LANGUAGE_CONFIG.en;

  if (
    config.requiresLogin &&
    !isLoggedIn
  ) {
    return;
  }

  if (
    config.speechEngine !==
    SPEECH_ENGINES.ELEVENLABS
  ) {

    return webSpeechEngine(
      text,
      config.speechLocale
    );
  }

  const play = () =>
    elevenLabsEngine(text, config.voiceId);

  if (hasElevenLabsCache(text, config.voiceId)) {
    return play();
  }

  return new Promise((resolve) => {
    playTimer = setTimeout(() => {
      playTimer = null;
      resolve(play());
    }, GENERATE_DEBOUNCE_MS);
  });
};
